export default __webpack_public_path__ + "static/media/bo_5.2b27a0cf.mp3";